// DEV UAT
 
//  export const BASE_URL = 'http://65.1.66.65:9009';

// CLIENT UAT

// export const BASE_URL = 'https://dev.itiamc.com:8443'; 

//CLIENT PROD 

export const BASE_URL = 'https://itiamc.com:8443'; 

//DR admin

// export const BASE_URL = 'https://drcatalog.itiamc.com:8443'; 

export const API_VERSION_PATH = 'jeeth/api/v1';

export const isEdata = false;

export const SERVICES = {
  CATALOG: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/catalog`,
  },
  CATALOG_STATUTORY: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/admin/catalog`,
  },
  PUSH_NOTIFICATION: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/pushnotification`,
  },
  PUSH_NOTIFICATIONS: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/pushnotifications`,
  },
  PUSH_NOTIFICATIONS_TAGS: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/gettag`,
  },
  LOGIN: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/login`,
  },
  LOGOUT: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/logout`,
  },
  REPORTS: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/report`,
    ARN_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/arn`,
    },
    FEEDBACK_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/feedback`,
    },
    TRANSACTION_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/transactionreport`,
    },
    LOGIN_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/loginreport`,
    },
    UNIQUE_LOGIN_COUNT_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/logincountreport`,
    },
    AUDIT_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/auditreport`,
    },
    USER_SESSION_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/sessionlogreport`,
    },
    INVESTOR_TRANSACTION_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/transactionreport/investor`,
    },
    INVESTOR_FEEDBACK_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/feedback`,
    },
    INVESTOR_LOGIN_REPORT: {
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/investorloginreport`,
    },
    USER_RIGHTS:{
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/userrights`,
    },
    ONLINE_OTM_REPORT:{
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/emandate`,
    },
    SIP_CANCELLATION_PAUSE:{
      PATH: `${BASE_URL}/${API_VERSION_PATH}/report/sipPauseCancel`,
    }
  },
  USER_MANAGMENT: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}`,
  },
  IFA_LIST: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/`,
  },
  INVESTOR_LIST: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/`,
  },
  USER_PASSWORD: {
    PATH: `${BASE_URL}/${API_VERSION_PATH}/changepassword`,
  },
};

export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  ACCEPT: 'Accept',
  EDATA: 'eData',
  BLOB: 'blob',
};

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};
